import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Category} from "./setting";
import {host} from "./api";

export interface CategoriesState {
    categories?: Array<Category>,
    status: Status,
    error: string | null | undefined
}

const initialState: CategoriesState = {
    categories: [],
    status: Status.Idle,
    error: null,
}

export const fetchCategories = createAsyncThunk('categories', async () => {
    const response = await axios.get(`${host}/component-categories`, {
        headers: headers(undefined)
    })
    return response.data
})

export const categorySlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCategories.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.categories = action.payload
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
    }
})
export default categorySlice.reducer;